import { Eye, Compass, Link2, MoveDiagonal, Sprout } from "lucide-react";
import Reveal from "@/components/site/Reveal";

const items = [
  { icon: Eye, label: "Voir autrement une situation" },
  { icon: Compass, label: "Comprendre des mécanismes familiaux" },
  { icon: Link2, label: "Mettre en lumière des loyautés invisibles" },
  { icon: MoveDiagonal, label: "Prendre du recul" },
  { icon: Sprout, label: "Engager un changement" },
];

export default function CBenefits() {
  return (
    <section
      data-testid="c-benefits"
      className="py-24 md:py-32 bg-[#FAF7F8]"
    >
      <div className="max-w-6xl mx-auto px-6 md:px-12">
        <div className="grid lg:grid-cols-12 gap-12 items-start">
          <div className="lg:col-span-5">
            <Reveal>
              <span className="text-sm uppercase tracking-[0.2em] text-[#C98FA3] font-medium">
                — Bénéfices
              </span>
              <h2 className="font-serif-display text-4xl md:text-5xl font-light mt-4 leading-[1.05]">
                Ce que ce travail permet
              </h2>
            </Reveal>
          </div>

          <div className="lg:col-span-7 space-y-3">
            {items.map(({ icon: Icon, label }, i) => (
              <Reveal key={label} delay={i * 0.06}>
                <div
                  data-testid={`c-benefit-${i}`}
                  className="flex items-center gap-5 p-5 md:p-6 bg-white rounded-2xl border border-[#DDD7E2] hover:border-[#C98FA3] hover:translate-x-1 transition-all duration-300"
                >
                  <span className="w-12 h-12 rounded-full bg-[#F3EEF4] flex items-center justify-center flex-shrink-0">
                    <Icon className="w-5 h-5 text-[#3A2E6E]" />
                  </span>
                  <p className="text-base md:text-lg text-[#1E1E2A]">{label}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
